import { createAsyncThunk } from '@reduxjs/toolkit'
import { loginAdmin, verifyOTP } from '../../api/admin' // Make sure this path matches where your login functions are defined

interface LoginCredentials {
  email: string
  password: string
}

interface OTPVerificationPayload {
  email: string
  otp: string
}

// Thunk for initiating admin login (OTP disabled - direct login)
export const adminLoginThunk = createAsyncThunk(
  'admin/login',
  async (credentials: LoginCredentials, { rejectWithValue }) => {
    try {
      const response = await loginAdmin(credentials)
      if (response.success) {
        // Direct login - return user and token
        return {
          user: response.user,
          token: response.token,
        }
      } else {
        return rejectWithValue(response.message)
      }
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)

// Thunk for verifying OTP and completing admin login
export const verifyOTPThunk = createAsyncThunk(
  'admin/verifyOTP',
  async (payload: OTPVerificationPayload, { rejectWithValue }) => {
    try {
      const response = await verifyOTP(payload)
      if (response.success) {
        return {
          user: response.user,
          token: response.token,
        }
      } else {
        return rejectWithValue(response.message)
      }
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)
